module.exports = __webpack_public_path__ + "img/judgement_closed.626369f0.png";